import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Header = () => {
  const { CurrentUser } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setMenuOpen(false); // Ensure menu is closed on larger screens
      }
    };
    handleResize(); // Set initial state
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  // Function to close the menu
  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <header style={headerStyle}>
      <Link to="/" aria-label="Go to Homepage" onClick={closeMenu}>
        <img src="/SMS_Texter_Logo.png" alt="SMS Texter Logo" style={logoStyle} />
      </Link>
      {isMobile && (
        <button
          style={menuToggleStyle}
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
        >
          ☰
        </button>
      )}
      <nav
        style={{
          ...navStyle,
          ...(menuOpen || !isMobile ? openNavStyle : closedNavStyle),
        }}
        role="navigation"
      >
        <ul
          style={{
            ...navListStyle,
            ...(isMobile ? mobileNavListStyle : desktopNavListStyle),
          }}
        >
          {navLinks.map((link) => (
            <li key={link.path} style={navItemStyle}>
              <Link
                to={link.path}
                style={{
                  ...linkStyle,
                  ...(location.pathname === link.path ? activeLinkStyle : {}),
                }}
                onClick={closeMenu} // Close the menu when a menu item is clicked
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

// Navigation links
const navLinks = [
  { path: '/otp', label: 'OTP Verification' },
  { path: '/pricing', label: 'Pricing' },
  { path: '/docs', label: 'Documentation' },
  { path: '/faq', label: 'FAQ' },
  { path: '/about', label: 'About Us' },
  { path: '/login', label: 'Login' },
];

// Styles
const headerStyle = {
  backgroundColor: '#333',
  padding: '2px 20px',
  position: 'sticky',
  top: 0,
  zIndex: 1000,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
};

const logoStyle = {
  height: 'auto',
  width: '75px',
};

const menuToggleStyle = {
  display: 'block',
  fontSize: '24px',
  color: 'white',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: '10px',
  position: 'absolute', // Use absolute positioning
  right: '20px', // Adjust the right positioning as necessary
};

const navStyle = {
  overflow: 'hidden',
  transition: 'max-height 0.3s ease',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
};

const openNavStyle = {
  maxHeight: '500px',
  visibility: 'visible',
};

const closedNavStyle = {
  maxHeight: '0',
  visibility: 'hidden',
};

const navListStyle = {
  listStyleType: 'none',
  padding: 0,
  margin: 0,
};

const desktopNavListStyle = {
  display: 'flex',
  gap: '30px',
  alignItems: 'center',
  marginLeft: 'auto', // Push navigation to the right of the logo
};

const mobileNavListStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '15px',
  justifyContent: 'center',
  padding: '20px 0', // Add spacing for mobile
  width: '100%',
};

const navItemStyle = {
  position: 'relative',
};

const linkStyle = {
  color: 'white',
  textDecoration: 'none',
  fontSize: '16px',
  fontWeight: '500',
  transition: 'color 0.3s ease, transform 0.3s ease',
};

const activeLinkStyle = {
  color: 'white',
  textDecoration: 'none',
  fontSize: '16px',
  fontWeight: '500',
  transition: 'color 0.3s ease, transform 0.3s ease',
};

export default Header;
